export default "__VITE_ASSET__XD2dThuM__";